import { CurrencySelect } from "@/components/select/CurrencySelect.tsx";
import { ValueFieldsProps } from "@/pages/talent/goals/components/key-result-form.types.ts";
import { Input } from "@skailer-com/uikit";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

export function CurrencyValueFields({ formHook, isCreating }: ValueFieldsProps) {
  const { t } = useTranslation();
  const {
    register,
    control,
    formState: { errors },
  } = formHook;

  return (
    <>
      <Controller
        control={control}
        name="currency"
        render={({ field: { value, onChange } }) => (
          <CurrencySelect
            label={t("common:currency")}
            emptyTitle={t("common:select")}
            value={value}
            onChange={onChange}
            required
            searchable
            error={errors.currency?.message as string | undefined}
          />
        )}
      />
      <Input
        {...register("start_value", {
          setValueAs: (value: string) => (value === "" ? null : Number(value)),
        })}
        type="number"
        label={t("goals:start_value")}
        required
        error={errors.start_value?.message as string | undefined}
      />
      {isCreating && (
        <Input
          {...register("current_value", {
            setValueAs: (value: string) => (value === "" ? null : Number(value)),
          })}
          type="number"
          label={t("goals:current_value")}
          error={errors.current_value?.message as string | undefined}
        />
      )}
      <Input
        {...register("target_value", {
          setValueAs: (value: string) => (value === "" ? null : Number(value)),
        })}
        type="number"
        label={t("goals:target_value")}
        required
        error={errors.target_value?.message as string | undefined}
      />
    </>
  );
}
